import { motion, useReducedMotion } from 'framer-motion';
import Skeleton from './Skeleton';
import './Table.css';

function Table({ columns, data, keyField = '_id', onRowClick, rowClassName, loading = false, skeletonRows = 5 }) {
  const reduceMotion = useReducedMotion();

  return (
    <div className="ds-table-wrap">
      <table className="ds-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={col.width ? { width: col.width } : undefined}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading &&
            Array.from({ length: skeletonRows }).map((_, i) => (
              <tr key={`skeleton-${i}`}>
                {columns.map((col) => (
                  <td key={col.key}>
                    <Skeleton height={14} width="70%" />
                  </td>
                ))}
              </tr>
            ))}

          {!loading &&
            data.map((row, index) => (
              <motion.tr
                key={row[keyField]}
                className={`${onRowClick ? 'ds-table-row-clickable' : ''} ${rowClassName ? rowClassName(row) : ''}`.trim()}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                initial={reduceMotion ? false : { opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.15, delay: Math.min(index * 0.03, 0.3), ease: [0.4, 0, 0.2, 1] }}
              >
                {columns.map((col) => (
                  <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
                ))}
              </motion.tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
